import axios, {AxiosInstance} from "axios";
import {getAdmitToken, handleAdmitRequired, isAdmitRequired} from "./waitingRoom";

/**
 * ★入場トークン（issue #2992 / 報告書 §8 No.11）を全リクエストに付ける。
 *   待合室が OFF のときはトークン自体が無いので何も付かない＝現状どおり。
 *
 * ★401 `ADMIT_REQUIRED` は **`useApi` と同じ共通ハンドラ**へ渡す（レビュー指摘）。
 *   以前はここでトークンを消すだけで再入場を通知しておらず、検索系 API の多くが
 *   待合室へ戻れず「取得できませんでした」の表示で止まっていた。
 */
const attachAdmitToken = (instance: AxiosInstance): AxiosInstance => {
    instance.interceptors.request.use((config) => {
        const token = getAdmitToken();
        if (token) {
            config.headers = {...(config.headers ?? {}), "X-Admit-Token": token};
        }
        return config;
    });
    instance.interceptors.response.use(
        (response) => {
            // validateStatus を差し替えている呼び出し元でも拾えるよう、成功側でも見る
            if (isAdmitRequired(response.status, response.data)) {
                handleAdmitRequired();
            }
            return response;
        },
        (error) => {
            if (isAdmitRequired(error?.response?.status, error?.response?.data)) {
                handleAdmitRequired();
            }
            return Promise.reject(error);
        }
    );
    return instance;
};

export const apiClient = attachAdmitToken(axios.create({
    baseURL: process.env.REACT_APP_FUNCTIONS_BASE_URL,
    headers: {
      "Content-Type": "application/json",
    },
}));


export const signalApiClient = (controller?: AbortController) => attachAdmitToken(axios.create({
    baseURL: process.env.REACT_APP_FUNCTIONS_BASE_URL,
    headers: {
        "Content-Type": "application/json",
    },
    signal: controller?.signal
}));
